import { render } from "./MathRoadMod.vue?vue&type=template&id=374cccaf&scoped=true"
import script from "./MathRoadMod.vue?vue&type=script&lang=js"
export * from "./MathRoadMod.vue?vue&type=script&lang=js"

import "./MathRoadMod.vue?vue&type=style&index=0&id=374cccaf&scoped=true&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374cccaf"]])

export default __exports__